import { render, staticRenderFns } from "./Mensalistas.vue?vue&type=template&id=332c0f7c&scoped=true&"
import script from "./Mensalistas.vue?vue&type=script&lang=js&"
export * from "./Mensalistas.vue?vue&type=script&lang=js&"
import style0 from "./Mensalistas.vue?vue&type=style&index=0&id=332c0f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c0f7c",
  null
  
)

export default component.exports